const hlxLogoAlt = require('./assets/hlx-logo-alt.jpg');
const sklsiLogo = require('./assets/sklsi-logo.png');
const burnHeaderImg = require('./assets/burn/burn_header.png');
const burnHeaderMobileImg = require('./assets/burn/burn_header_mobile.png');
const maciHeaderImg = require('./assets/maci/maci_header.png');
const maciHeaderMobileImg = require('./assets/maci/maci_header_mobile.png');
const burnFavicon = require('./assets/burn/burn_favicon.png');
const maciFavicon = require('./assets/maci/maci_favicon.png');

export default {
  sobix: {
    clientName: 'HELIX',
    customHeaderLogo: hlxLogoAlt
  },
  sklsi: {
    headerTitle: 'Educational Peer Event Registration',
    customHeaderLogo: sklsiLogo
  },
  axsomeprograms: {
    clientName: 'HELIX',
    landingInputLabel: 'Invitation Code',
    additionalInviteCodeFormat: '^(\\d+):(\\d+)$'
  },
  burn: {
    headerBanner: burnHeaderImg,
    headerBannerMobile: burnHeaderMobileImg,
    headerBannerAlt: 'Burn',
    pageTitle: 'Burn Event Registration',
    favicon: burnFavicon,
    footerLines: [
      [
        { text: 'Vericel® and the Vericel logo are registered', block: true },
        { text: ' trademarks of Vericel Corporation.' }
      ],
      [
        { text: '©2026 Vericel Corporation. All rights', block: true },
        { text: ' reserved. PP.US.VBC.0012' }
      ]
    ]
  },
  maci: {
    headerBanner: maciHeaderImg,
    headerBannerMobile: maciHeaderMobileImg,
    headerBannerAlt: 'MACI',
    pageTitle: 'MACI Event Registration',
    favicon: maciFavicon,
    hasIsi: true,
    footerLines: [
      [
        { text: 'MACI®, MACI Arthro®, Vericel®, and the', block: true },
        { text: ' ' },
        { text: 'Vericel logo are registered trademarks', block: true },
        { text: ' of Vericel Corporation.' }
      ],
      [
        { text: '©2026 Vericel Corporation. All rights', block: true },
        { text: ' reserved. PP.US.MAC.3041' }
      ]
    ]
  }
};
